import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { AngularMultiSelect } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { Modal } from "ngx-modal";
import { PaginationInstance } from 'ngx-pagination';
import { environment } from '../../../../environments/environment';
import { AccessLevel } from "../../../common/enums/access-level.enum";
import { AuthorizationExtensionPipe } from "../../../common/pipes/authorization-extension.pipe";
import { MessageService } from "../../../shared/services/message.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { ManageUserTab } from "../../models/manage-user-tab-model";
import { DepartmentService } from "../../services/department.service";
import { Permission } from "./../../../common/enums/permission.enum";
import { CacheKey } from './../../../shared/constants/cachekey.constants';
import { UserInfo } from './../../../shared/interface/user-info.interface';
import { CacheService } from "./../../../shared/services/cache.service";
import { CommonService } from "./../../../shared/services/common.service";
import { User } from "./../../models/user";


@Component({
    selector: "department-user-search",
    templateUrl: "../../templates/template1/views/department/department-user-search.component.html",
    styleUrls: ["../../templates/template1/themes/default/css/department.less"],
    providers: [AuthorizationExtensionPipe,DepartmentService]
})
export class DepartmentUserSearchComponent implements OnInit { 

  ManageUserPermissions: any[] = [Permission.MANAGE_DEPARTMENT_USERS_EDIT,Permission.MANAGE_DEPARTMENT_USERS_ASSIGN,Permission.MANAGE_DEPARTMENT_USERS_VIEW];

  @Input() departmentId: number;
  @Input() operatingCountryId:number;
  users: User[];
  pageNumber: number = 1;
  pageSize: number = 10;
  pageCount: number = 0;
  sortColumn: string;
  departmentOnSelectAll: boolean = true;
  isDesc: boolean;
 @ViewChild('unassignUserModal') unassignUserModal: Modal;
  userInfo: UserInfo;
  message: string = "";
   public userModalPopup: any = {
      isTicketsAssigned:false,
      userId:0,
      message:''
   };

  roles: any[];
  roleOnSelectAll: boolean = true;
  roleIds:any[];
  firstName:String;
  lastName:String;
  userName:String;

  editUserPermission:boolean;
  viewUserPermission:boolean;
  assignUserPermission:boolean;
  @ViewChild('dropdownElem') dropdownElem: AngularMultiSelect;
 

  public paginationInstance: PaginationInstance = {
    id: 'dpt-user-search-pagination',
    itemsPerPage: 10,
    currentPage: 1
  };

   public dropdownSettings: any = {
        rolesDropdown: [],
        roleSelectedItems: [],
        roleIndex: 1,        
        settings: {}, 
    };

    constructor(
      private _translatePipe: TranslateService, private _cacheService: CacheService, private _commonService: CommonService,
      private _departmentService: DepartmentService, private messageService: MessageService) {
    }
 
    ngOnInit() {
      
      this.setFocusToTextBox();
       this.userInfo = this._cacheService.get(CacheKey.UserInfo);
      const userLoginIdElement = document.getElementById("userLoginId");
      if (userLoginIdElement) {
        userLoginIdElement.focus();
      }  
       this.dropdownSettings.settings = {
            singleSelection: false,
            text: "Select Role",
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            enableSearchFilter: false,
            classes: "myclass custom-class",
            badgeShowLimit: 1
      }; 
     this.bindDepartmentLevelRoles();
     this.searchUsers();   

    
     this.editUserPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageUserPermissions[0] + "]"),AccessLevel.Department,this.departmentId); 
     this.assignUserPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageUserPermissions[1] + "]"),AccessLevel.Department,this.departmentId); 
     this.viewUserPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageUserPermissions[2] + "]"),AccessLevel.Department,this.departmentId); 
  }
  setFocusToTextBox(){
    
    setTimeout(function(){ 
      const userLoginIdElement = document.getElementById("userLoginId");
      if (userLoginIdElement) {
        userLoginIdElement.focus();
      }
     }, 200);
  }

  usersSearchSubmit() {   
    this.searchUsers();    
    const userLoginIdElement = document.getElementById("userLoginId");
    if (userLoginIdElement) {
      userLoginIdElement.focus();
    }  
  }

  searchUsers() {
    
    window.document.getElementById("search-button").classList.add('button-active');
        setTimeout(() => {
            window.document.getElementById("search-button").classList.remove('button-active');
        }, 1000);
    let loggedinUserId = +this._cacheService.get(CacheKey.UserId);
    this._departmentService.searchUsersWithPagination(this.departmentId, this.userName, this.firstName, this.lastName,this.roleIds, loggedinUserId,
            this.pageSize, this.pageNumber, !this.isDesc, this.sortColumn).subscribe((response:any) => {
        if (response != null) {                    
          this.pageCount = response["totalCount"]
          this.users = response["content"]
        } else {
          this.pageCount = 0;
          this.users = [];
        }
      }, (error:any) =>
        this.message = <any>error
      );      
  }

  pageChange(pageNumber: number) {
    this.pageNumber = pageNumber;
    this.searchUsers();
  }  

  sort(sortColumn: string) {
    this.pageNumber = 1;
    this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
    this.sortColumn = sortColumn;
    this.searchUsers();
  }

  unassignUserFromDepartment(userId:Number) {  
    
     this._departmentService.unassignUser(this.departmentId,userId).subscribe(response => {
      if (response.isSuccess) {
        let success: any = this._translatePipe.get("validation-message.User has been unassigned successfully");
        this.message = response.validations != null && response.validations.length > 0 ? response.validations[0].message : '';
        this._commonService.createNotification("", success.value, NotificationType.SUCCESS);
        this.searchUsers();
      }
      else {
        let failed: any = this._translatePipe.get("validation-message.Your attempt to unassign user is failed");    
        this._commonService.createNotification("", failed.value, NotificationType.ERROR);
      }
    }, error => {
      let unknown: any = this._translatePipe.get("validation-message.Unknown Error");
      this.message = (error != null && error[0] != null) ? error[0].field + " : " + error[0].message : unknown.value;
      this._commonService.createNotification("", this.message, NotificationType.ERROR);
    });
     this.unassignUserModal.close();

  }

  unAssignUser(userId: any) { 
   this.userModalPopup.userId=+userId;
     this._departmentService.getUserTicketsStatusForDepartment(this.departmentId,userId).subscribe(response => {
            if (response) {
                this.userModalPopup.isTicketsAssigned = response;
                let ticketAssigned: any = this._translatePipe.get("validation-message.Currently user has assigned tickets. Do you want to continue to unassign this user from department ?");
                this.userModalPopup.message = ticketAssigned.value;
            }
            else{
                this.userModalPopup.isTicketsAssigned = false;
                let popUpMessage: any = this._translatePipe.get("validation-message.Do you want to continue to unassign this user from department ?");
                this.userModalPopup.message = popUpMessage.value;
            }
             this.unassignUserModal.open();
        }); 
  }

  getImageURL(){
    let deleteButtonURL = environment.uiTemplateBaseUrl + '/images/cross-button.png';
    return deleteButtonURL;
  }

  closeUnAssignUserPopUp(){
    this.unassignUserModal.close();
  }
  clearFields(){
      this.setFocusToTextBox();
      this.pageNumber = 1;
      this.pageCount = 10;
      this.roleIds = [];  
      this.firstName ="";
      this.userName = "";
      this.lastName ="";
      this.searchUsers();
    const userLoginIdElement = document.getElementById("userLoginId");
    if (userLoginIdElement) {
      userLoginIdElement.focus();
    }
   }
   
  goToUserView(userId:number,firstName:string)
  {
   
   let managerUserTab = new ManageUserTab();
    managerUserTab.active = true;
    managerUserTab.assignUserTab= false;
    managerUserTab.departmentID = this.departmentId;
    managerUserTab.userId = userId;
    managerUserTab.disabled = false;
    managerUserTab.managerUserTab = true;
    managerUserTab.removable = true;
    managerUserTab.title = "Manage User";
    managerUserTab.operatingCountryId = this.operatingCountryId; 
    this.messageService.setManageUserTab(managerUserTab);
    this.departmentOnSelectAll = true;
   }

    goToAssignUserView()
     {        
       let assignUserTab=new ManageUserTab();
       assignUserTab.active = true;
       assignUserTab.assignUserTab= true;
       assignUserTab.departmentID = this.departmentId;
       assignUserTab.disabled = false;
       assignUserTab.managerUserTab = false;
       assignUserTab.removable = true;       
       assignUserTab.operatingCountryId = this.operatingCountryId;
       assignUserTab.title = "Assign User";
       this.messageService.setManageUserTab(assignUserTab);
     }

     bindDepartmentLevelRoles() {
       this.dropdownSettings.rolesDropdown =[];
      this._departmentService.getRoles().subscribe((response: any) => {          
       if (response) {
          this.roles = response;              
          this.roles.forEach(item => {
              this.dropdownSettings.rolesDropdown.push({ id: item.id, itemName: item.name });
          }); 
          this.dropdownSettings.roleSelectedItems= JSON.parse(JSON.stringify(this.dropdownSettings.rolesDropdown));
      }
    });
  }

     openDropDown(element:string) {
        var elem = document.getElementById(element)
        var dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute("hidden");
    }
    onDropDowneBlur(element:string) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute("hidden", "true");
    }

    onItemSelect(item: any, indexValue: any) {
       this.roleIds =[];        
       if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = false;
             if(this.roles.length === this.dropdownSettings.roleSelectedItems.length){
                     this.roleOnSelectAll=true;                   
             }
            this.dropdownSettings.roleSelectedItems.forEach(item => {
                this.roleIds.push(item.id);
             }); 
        } 
    }

  
   onItemDeSelect(item: any, indexValue: any) {
     this.roleIds =[];
      if (this.dropdownSettings.roleIndex === +indexValue) {
          this.roleOnSelectAll = false;
      }     
      this.dropdownSettings.roleSelectedItems.forEach(item => {
           this.roleIds.push(item.id);
      }); 
    }

     onSelectAll(items: any, indexValue: any) {
        this.roleIds =[];
        if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = true;
        }    
         this.dropdownSettings.roleSelectedItems.forEach(item => {
                this.roleIds.push(item.id);
          });     
    }

    onDeSelectAll(items: any, indexValue: any) { 
       this.roleIds =[];      
        if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = false;
        }       
    }

    close(evt: any) {
      this.dropdownElem.closeDropdown();
    }
    
  }



// WEBPACK FOOTER //
// ./src/app/customerservice/components/department/department-user-search.component.ts